<template>
  <div>
    <div
      class="columns is-gapless is-border-top"
      :class="idx > 0 ? 'has-background-white' : 'has-background-light'">
      <div
        class="column columns is-gapless is-multiline is-padding-left-small is-padding-right-small is-padding-top is-padding-bottom">
        <div class="column is-5 is-padding-xxsmall">
          <div class="title is-5 has-text-weight-medium is-margin-bottom-small">
            <span class="is-uppercase">{{ currentNotaire.label }}<span v-if="idx > 1"> {{ idx }}</span></span>
          </div>
        </div>
        <div class="column is-7 is-padding-xxsmall">
          <div
            v-if="currentNotaire.name"
            class="title is-5 has-text-weight-medium is-margin-bottom-small">
            <span class="is-uppercase">{{ currentNotaire.name }}</span>
          </div>
          <div>
            <span
              v-if="notaireEmpty"
              class="is-size-6 is-uppercase">Aucune information renseignée</span>
          </div>
          <div class="title is-5">
            <div
              class="is-uppercase"
              v-if="currentNotaire && currentNotaire.address">
              <span
                v-if="currentNotaire.address && currentNotaire.address.line1">{{ currentNotaire.address.line1 }}</span>
              <br v-if="currentNotaire.address.line1">
              <span v-if="currentNotaire.address && currentNotaire.address.zip_code || currentNotaire.address.city">{{ currentNotaire.address.zip_code }} {{ currentNotaire.address.city }}</span>
              <br v-if="currentNotaire.address.zip_code || currentNotaire.address.city">
              <span
                v-if="currentNotaire.address && currentNotaire.address.country">{{ currentNotaire.address.country }}</span>
            </div>
            <div class="is-margin-top-xxsmall">
              <span v-if="currentNotaire.phone">
                <span class="icon is-small is-margin-right-xxsmall"><i class="fal fa-phone-office"></i></span>
                <phone-number
                  phone-class="is-margin-right-small"
                  :phone="currentNotaire.phone"></phone-number>
              </span>
              <span v-if="currentNotaire.email">
                <span class="icon is-smal"><i class="fal fa-paper-plane"></i></span>
                <span class="is-uppercase">{{ currentNotaire.email }}</span>
              </span>
            </div>
            <div
              v-if="ficheInterlocuteur"
              class="is-margin-top-xxsmall is-size-6">
              <span class="icon is-small is-margin-right-xxsmall"><i class="fal fa-user"></i></span>
              <span class="is-uppercase">{{ ficheInterlocuteur.last_name }}</span> {{ ficheInterlocuteur.first_name }}
              <span
                v-if="ficheInterlocuteur.role"
                class="has-text-grey"> — {{ ficheInterlocuteur.role }}</span>
              <phone-number
                v-if="ficheInterlocuteur.phone"
                phone-class="is-margin-left-small"
                :phone="ficheInterlocuteur.phone"></phone-number>
              <span
                v-if="ficheInterlocuteur.email"
                class="is-margin-left-small">{{ ficheInterlocuteur.email }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="actionsOnRow actionsOnRow--vertical">
        <div
          v-if="canEdit"
          class="">
          <button
            @click="openModalNotaire()"
            class="tooltip is-tooltip-left"
            data-tooltip="Modifier le notaire">
            <span class="icon"><i class="fal fa-marker"></i></span>
          </button>
        </div>
        <div
          v-if="idx > 0 && canEdit"
          class="">
          <button
            @click="removeNotaire"
            class="tooltip is-tooltip-left actionsOnRow-btn--hoverIsDanger"
            data-tooltip="Supprimer le notaire">
            <span class="icon"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import { TIERS_RESOURCE } from '@/components/tiers/tiersConstants'
export default {
  name: 'NotaireItem',
  props: {
    sourceNotaire: {
      type: Object,
      required: true
    },
    idx: {
      type: Number,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentNotaire: null,
      savedNotaire: null,
      pendingInput: false,
      selectedRow: 'notaire-',
      ficheInterlocuteur: null
    }
  },
  computed: {
    ...mapState(['modal']),
    /**
      * notaire is empty
      * @returns {boolean}
      */
    notaireEmpty () {
      return (this.currentNotaire.name === null || this.currentNotaire.name === '') &&
          (this.currentNotaire.address.line1 === null || this.currentNotaire.address.line1 === '') &&
          (this.currentNotaire.address.zip_code === null || this.currentNotaire.address.zip_code === '') &&
          (this.currentNotaire.address.city === null || this.currentNotaire.address.city === '') &&
          (this.currentNotaire.address.country === null || this.currentNotaire.address.country === '') &&
          (this.currentNotaire.phone === null || this.currentNotaire.phone === '') &&
          (this.currentNotaire.email === null || this.currentNotaire.email === '')
    }
  },
  watch: {
    sourceNotaire () {
      return this.init()
    },
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'NOTAIRE_CONTACT' && params.idx === this.selectedRow) {
          this.editNotaire(results)
        }
      }
    }
  },
  created () {
    this.selectedRow = this.selectedRow + this.idx
    this.init()
  },
  methods: {
    /**
      * emit edit notaire
      * @param {object}
      */
    editNotaire (val) {
      this.$emit('editNotaire', { idx: this.idx, notaire: val })
    },
    /**
      * init notaire data
      */
    init () {
      this.currentNotaire = this.sourceNotaire
      this.savedNotaire = cloneDeep(this.sourceNotaire)
      this.pendingInput = false
      if (this.currentNotaire.address === null) {
        let address = {
          city: null,
          country: null,
          line1: null,
          line2: null,
          region: null,
          state: null,
          zip_code: null
        }
        this.currentNotaire.address = Object.assign({}, address)
      }
      this.refreshFromReferentiel()
    },
    /**
      * CDC : la fiche est la source unique — si un tiers_id est présent,
      * l'affichage reflète la fiche du référentiel (la copie locale sert de secours)
      */
    async refreshFromReferentiel () {
      this.ficheInterlocuteur = null
      if (!this.currentNotaire.tiers_id) return
      try {
        let { data } = await this.$api.getOne(TIERS_RESOURCE, this.currentNotaire.tiers_id)
        this.$set(this.currentNotaire, 'name', data.name)
        this.$set(this.currentNotaire, 'phone', data.phone)
        this.$set(this.currentNotaire, 'email', data.email)
        if (data.address) {
          this.$set(this.currentNotaire, 'address', Object.assign({}, this.currentNotaire.address, data.address))
        }
        if (this.currentNotaire.interlocuteur_id) {
          this.ficheInterlocuteur = (data.interlocuteurs || [])
            .find(i => i.pk === this.currentNotaire.interlocuteur_id) || null
        }
      } catch (e) {
      }
    },
    /**
      * open edit notaire modal
      */
    openModalNotaire () {
      let params = {
        title: this.currentNotaire.label,
        source: { ...this.currentNotaire },
        idx: this.selectedRow
      }
      this.$store.commit('setModal', { mode: 'NOTAIRE_CONTACT', params })
    },
    /**
      * emit remove notaire
      */
    removeNotaire () {
      this.$emit('removeNotaire', this.idx)
    }
  }
}
</script>
